/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechLivekitToken } from "../../funcs/llmSpeechLivekitToken.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.LivekitTokenRequest$inboundSchema,
};

export const tool$llmSpeechLivekitToken: ToolDefinition<typeof args> = {
  name: "llm-speech-livekit-token",
  description: `Generate LiveKit room token

Generates a LiveKit access token for joining a real-time voice room. The token includes encrypted credentials and model configuration for the voice agent.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechLivekitToken(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
